import { FC } from 'react';

import { Button } from '@shared';
import { toLangCode } from '@utils/routeHelpers';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import { TLanguage } from '../../general/_models/general';
import './languagePicker.scss';

type TProps = {
  languages: TLanguage[];
};

const LanguagePicker: FC<TProps> = ({ languages }) => {
  const { t } = useTranslation();

  if (!languages) return null;

  function handleChange(fullCode: string) {
    i18next.changeLanguage(fullCode);
    localStorage.setItem('preferredLanguage', fullCode);

    // Update the URL basename segment (clientType/lang/...rest)
    const urlSegments = window.location.pathname.split('/').filter(s => s);
    const clientType = urlSegments[0];
    const remainingSegments = urlSegments.slice(2);
    const shortCode = toLangCode(fullCode);
    const newPath = `/${[clientType, shortCode, ...remainingSegments].join('/')}`;
    window.location.replace(newPath);
  }

  return (
    <div className="language-picker">
      <h2 className="visually-hidden">{t('FOOTER.LANGUAGE.TITLE')}</h2>
      <ul>
        {languages.map(language => (
          <li key={language.code}>
            <Button onClick={() => handleChange(language.code)} theme="plain-link">
              {language.name}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default LanguagePicker;
